export const mutations = {
  STORE_EMPLOYEES (state, employees) {
    state.employees = employees
  },
  STORE_EMPLOYEES_UPDATE (state, employeeId) {
    let Employee = state.employees.find(function(employees) {
      return employees.id === employeeId
    })
    state.systemEmployee = Employee
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/vuex/modules/employees/mutations.js